import React, { useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import DeletCode from './DeletCode'
import trash from '../../assets/icons/trash.svg'
import undo from '../../assets/icons/undo.svg'
import ChangeCodeStatus from './ChangeCodeStatus'

const CodeRow = ({ code, index }) => {
  console.log(code)
  const [delet, setDelet] = useState(false)
  const [change, setChange] = useState(false)

  function formatDate(dateString) {
    const options = { year: '2-digit', month: '2-digit', day: '2-digit' }
    const date = new Date(dateString)
    return date.toLocaleDateString('en-GB', options)
  }
  return (
    <>
      <div
        className={`${
          code.status === 'rejected'
            ? 'bg-red/10 border-b-[1px] border-b-red'
            : code.status === 'archive'
            ? ' bg-blueButton/20 border-b-[1px] border-b-blueButton'
            : index % 2 === 0
            ? ''
            : ' bg-gray/20'
        } py-2 flex`}
      >
        <div className="flex-1 p-2 items-center justify-center flex">
          {code.title}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          {code.status}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          {formatDate(code.created_at)}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex gap-4 ">
          {code.status === 'active' && (
            <div
              onClick={() => setDelet(true)}
              className=" w-7 h-7 flex cursor-pointer justify-center items-center"
            >
              <img src={trash} alt="" className=" w-full" />
            </div>
          )}
          {code.status === 'archive' && (
            <div
              onClick={() => setChange(true)}
              className=" w-7 h-7 flex cursor-pointer justify-center items-center"
            >
              <img src={undo} alt="" className=" w-full" />
            </div>
          )}
        </div>
      </div>

      <AnimatePresence>
        {delet && (
          <DeletCode active={delet} close={() => setDelet(false)} code={code} />
        )}

        {change && (
          <ChangeCodeStatus
            active={change}
            close={() => setChange(false)}
            code={code}
          />
        )}
      </AnimatePresence>
    </>
  )
}

export default CodeRow
